import { PaginationRequest, PaginationResult } from '@monorepo/types';
import BaseEntityService, { BaseResponse } from './base-entity-service';

export class CrudService extends BaseEntityService {
  async create<T>(payload: Record<string, unknown>): Promise<T> {
    const response = await this.httpService.post<
      Record<string, unknown>,
      BaseResponse<Record<string, unknown>>
    >(`${this.path}`, payload);

    return response.data as T;
  }

  async getAll<T>(queryString = ''): Promise<T[]> {
    let url = `${this.path}`;

    if (queryString) {
      url += `?${queryString}`;
    }

    const response = await this.httpService.get<BaseResponse<T[]>>(url);

    return response.data as T[];
  }

  async paginate<T>(
    paginateRequest: PaginationRequest<T>,
  ): Promise<PaginationResult<T>> {
    const url = `${this.path}/paginate`;

    const response = await this.httpService.get<BaseResponse<PaginationResult>>(
      url,
      {
        params: paginateRequest,
      },
    );

    return response.data as PaginationResult<T>;
  }

  async get<T = any>(id: string) {
    const response = await this.httpService.get<BaseResponse<T>>(
      `${this.path}/${id}`,
    );

    return response.data;
  }

  async update(id: string, data: Record<string, unknown>) {
    let url = `${this.path}`;

    if (id) {
      url += `/${id}`;
    }
    const response = await this.httpService.put<
      Record<string, unknown>,
      BaseResponse<Record<string, unknown>>
    >(url, data);

    return response.data;
  }

  async patch(id: string, data: Record<string, unknown>) {
    let url = `${this.path}`;

    if (id) {
      url += `/${id}`;
    }
    const response = await this.httpService.patch<
      Record<string, unknown>,
      BaseResponse<Record<string, unknown>>
    >(url, data);

    return response.data;
  }

  async delete(id: string) {
    const response = await this.httpService.delete<
      BaseResponse<Record<string, unknown>>
    >(`${this.path}/${id}`);

    return response.data;
  }
}
